import "./Watermark.css";

const Watermark = () => {
  let dynamicContent;
  const chatEnv = sessionStorage.getItem("chatEnv");
  if (chatEnv === "prod") {
    dynamicContent = " production ".repeat(45);
  } else if (window.location.hostname === "localhost" || chatEnv === "local") {
    dynamicContent = " local ".repeat(45);
  } else if (
    window.location.hostname === "alpha.chat.conncen.test.c1.statefarm" ||
    window.location.hostname ===
      "alpha-static.chat.conncen.test.c1.statefarm" ||
    chatEnv === "alpha"
  ) {
    dynamicContent = " alpha ".repeat(45);
  } else if (chatEnv === "beta") {
    dynamicContent = " beta ".repeat(45);
  }
  return dynamicContent && <div className="watermark">{dynamicContent}</div>;
};

export default Watermark;
